import * as yup from 'yup';

export const validateRequestViewForm = yup.object({
  firstName: yup.string().required('First name is a required field'),
  lastName: yup.string().required('Last name is a required field'),
  gender: yup.string().required('Gender is a required field'),
  dob: yup.string().required('Date of birth is a required field')
});
